'use strict';

class Mobilebar {
  constructor($scope, originatorService) {
    this.$scope = $scope;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.load();

    this.$scope.$on('originatorSettingsUpdated', () => {
      this.load();
    });
  }

  load() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });
  }
}

Mobilebar.$inject = ['$scope', 'originatorService'];

const mobilebar = {
  controller: Mobilebar,
  template: `
    <div>
        <div class="small-7 columns right-align show-for-small">
          <a href class="fa fa-bars" ng-click="toggleNav = !toggleNav"></a>
          <ul class="no-bullet" ng-show="toggleNav">
            <li ng-show="$ctrl.originator && $ctrl.originator.giroLayout"><a href="#/regning/kladd/ny">Ny regning</a></li>
            <li ng-show="$ctrl.originator && !$ctrl.originator.giroLayout"><a href="#/regning/kladd/utengiro/ny">Ny regning</a></li>
            <li><a href="#/oversikt">Oversikt</a></li>
            <li><a href="#/beslutning-kreves">Beslutning kreves</a></li>
            <li><a href="#/kundeliste">Kundeliste</a></li>
            <li><a href="#/produkt">Produktliste</a></li>
            <li><a href="#/rapport">Rapporter</a></li>
            <li><a href="#/tilbud">Tilbud</a></li>
            <li><a href="#/ordrebekreftelse">Ordrebekreftelser</a></li>
            <li><a href="#/fast-oppdrag">Fast oppdrag</a></li>
            <li><a href="#/masseutsendelse">Ny masseutsendelse</a></li>
            <li><a href="#/vert">Arrangement</a></li>
            <li><a href="#/timeregistrering">Timeregistrering</a></li>
            <li><a href="#/konto">Konto</a></li>
            <li><a href="#/bruker">Bruker</a></li>
            <li><a href="#/personvern">Personvern (GDPR)</a></li>
            <li><a href="/priser/">Priser</a></li>
            <li><a href="/hjelp/">Hjelp</a></li>
            <li><logout></logout></li>
          </ul>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('mobilebar', mobilebar);
